import { render } from "./KycView.vue.ts?vue&type=template&id=907f9da5&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./KycView.vue?vue&type=template&id=907f9da5&ts=true"
import script from "./KycView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./KycView.vue?vue&type=script&setup=true&lang=ts"
export * from "./KycView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./KycView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/views/steps/KycView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "907f9da5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('907f9da5', __exports__)) {
    api.reload('907f9da5', __exports__)
  }
  
  module.hot.accept("./KycView.vue.ts?vue&type=template&id=907f9da5&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./KycView.vue?vue&type=template&id=907f9da5&ts=true", () => {
    api.rerender('907f9da5', render)
  })

}


export default __exports__